import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {ISimpleGridEdit} from "./SimpleGrid";
import * as _ from 'lodash';

@Component({
  selector: 'td[simpleGridData]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    label {
      padding: 0;
      margin: 0;
    }
    .editableLabel {
      cursor: pointer;
    }
    input {
      padding: 0;
      margin: 0;
    }
    a {
      cursor: pointer;
    }
  `],
  template: `
    @if (!_editing) {
      <label [ngClass]="{editableLabel: _editable}" (click)="onEdit(true)">{{value}}</label>
    }
    @if (_editing) {
      <span>
        <input value="{{value}}" [ngModel]="value" (ngModelChange)="changeEvent($event)"/>
        <a (click)="onEdit(false)">
          <mat-icon style="color: green; padding-left: 5px; position: relative; top: 4px">check</mat-icon>
        </a>
      </span>
    }
    
    <!--<img src="{{ item.iconPath }}" style="width: 40px; height: 40px"/>-->
    <!--&lt;!&ndash; <td [innerHtml]="item.day"></td> &ndash;&gt;-->
    `
})
export class SimpleGridDataComponent {
  value = '';
  newValue = '';
  storeModel;
  _editable: boolean | string = false;
  _editing = false;
  _field;

  @Input()
  set item(i_storeModel) {
    this.storeModel = i_storeModel;
    if (this._field)
      this.value = _.get(this.storeModel, this._field);
  }

  @Input()
  set field(i_field) {
    this._field = i_field;
    this.value = _.get(this.storeModel, i_field);
  }

  @Input()
  set processField(i_processField: (storeModel) => string) {
    this.value = i_processField(this.storeModel);
  }

  @Input()
  set editable(i_editable) {
    this._editable = i_editable;
  }

  @Output()
  labelEdited: EventEmitter<any> = new EventEmitter();

  changeEvent(newValue) {
    this.newValue = newValue;
    // console.log(newValue, this.value);
  }

  onEdit(value: any) {
    if (this._editable === false || this._editable === 'false') return;
    this._editing = value;
    if (this._editing)
      return;
    if (this.newValue.length === 0 || this.newValue === this.value) return;
    this.value = this.newValue;
    const payload: ISimpleGridEdit = {value: this.value, item: this.storeModel};
    this.labelEdited.emit(payload);
  }
}
